export var ACCESS_TOKEN_COOKIE_NAME = "lll_oidc_token";
export var LOCAL_STORAGE_KEY_NAME = "lll-profile";
